<template>
  <div>
    <van-nav-bar title="社保公积金明细" left-text="返回" left-arrow @click-left="onClickLeft" @click-right="onClickRight" />
    <van-cell :value="timeValue" title="请选择属期" is-link @click="show2 = true" />
    <van-popup v-model="show2" :style="{ height: '30%' }" position="bottom" close-icon="close">
      <van-datetime-picker
        v-model="currentDate"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        type="year-month"
        title="选择年月"
        @cancel="show2 = false"
        @confirm="_datex(currentDate)"
      />
    </van-popup>
    <div >
      <div v-if="social.is_show ">
        <div class="xa ax">
          <van-row>
            <van-col span="6">
              姓名 :
              <span style="color: crimson;">{{ social.name }}</span>
            </van-col>
            <van-col span="8">基数</van-col>
            <van-col span="4" style="font-size: 14px;">比例</van-col>
            <van-col span="6">金额</van-col>
          </van-row>
        </div>
        <div class="xa">
          <van-row>
            <van-col span="4" class="ma xc">养老</van-col>
            <van-col span="2" class="max xxx">
              企业
              <br >
              <span style="border-top: 1px solid gray; display: inline-block; width: 30px;">个人</span>
            </van-col>
            <van-col span="8" class="ma xc axx">{{ social.pension_client_base }}</van-col>
            <van-col span="2" class="ma xx">
              {{ social.pension_client_ratio }}%
              <br >
              {{ social.pension_person_ratio }}%
            </van-col>
            <van-col span="4" class="ma xx mc">
              {{ social.client_money }}
              <br >
              {{ social.person_money }}
            </van-col>
          </van-row>
          <div class="xa">
            <van-row>
              <van-col span="4" class="ma xc">失业</van-col>
              <van-col span="2" class="max xxx">
                企业
                <span style="border-top: 1px solid gray; display: inline-block; width: 30px;">个人</span>
              </van-col>
              <van-col span="8" class="ma xc axx">{{ social.unemp_upper_base }}</van-col>
              <van-col span="2" class="ma xx">
                {{ social.unemp_client_ratio }}%
                <br >
                {{ social.unemp_person_ratio }}%
              </van-col>
              <van-col span="4" class="ma xx mc">
                {{ social.unemp_client_money }}
                <br >
                {{ social.unemp_person_money }}
              </van-col>
            </van-row>
          </div>

          <div class="xa">
            <van-row>
              <van-col span="4" class="ma xc">工伤</van-col>
              <van-col span="2" class="ma xc" style="font-size: 12px;">企业</van-col>
              <van-col span="8" class="ma xc axx">{{ social.injuries_upper_base }}</van-col>
              <van-col span="2" class="ma xc xx" style="text-align: right;font-size: 14px;">{{ social.injuries_client_ratio }}%</van-col>
              <van-col span="4" class="ma xc xx mc" style="text-align: right;font-size: 14px;">{{ social.injuries_money }}</van-col>
            </van-row>
          </div>
          <div class="xa">
            <van-row>
              <van-col span="4" class="ma xc">医疗</van-col>
              <van-col span="2" class="max xxx">
                企业
                <br >
                <span style="border-top: 1px solid gray; display: inline-block; width: 30px;">个人</span>
              </van-col>
              <van-col span="8" class="ma xc axx ">{{ social.hosp_upper_limit }}</van-col>
              <van-col span="2" class="ma xx">
                {{ social.hosp_client_ratio }}%
                <br >
                {{ social.hosp_person_ratio }}%
              </van-col>
              <van-col span="4" class="ma xx mc">
                {{ social.hosp_client_upper_money }}
                <br >
                {{ social.hosp_person_upper_money }}
              </van-col>
            </van-row>
          </div>

          <div class="xa">
            <van-row>
              <van-col span="4" class="ma xc" style="color: red;">合计</van-col>
              <van-col span="4" />
              <van-col span="14" class="ma xc" style="text-align: left;">
                <span style="color: darkorange;">{{ social.person_total }}</span>
                <span style="font-size: 12px;padding-right: 20px;">(个人)</span>
                <span style="color: darkorange;">{{ social.client_total }}</span>
                <span style="font-size: 12px;">
                  (企业)
                  <span />
                </span>
              </van-col>
            </van-row>
          </div>
          <div class="xa">
            <van-row>
              <van-col span="4" class="ma xc" style="color: #008C00;">总计</van-col>
              <van-col span="4" />
              <van-col span="14" class="ma xc" style="font-size: 14px;color: orange; text-align: left;">{{ social.total }}</van-col>
            </van-row>
          </div>
        <!-- </van-row> -->
        </div>
      </div>
    </div>

    <div v-if="fund[0]">
      <div v-if="fund[0].is_show">

        <div v-if="fund" style="background-color: #FDFDFD;">
          <van-row justify="center" style="text-align: center;height: 30px;line-height: 30px;border-bottom: brown 1px solid;border-right: brown 1px solid; color: #FF8C00">
            <van-col span="24">公积金信息</van-col>
          </van-row>
          <div class="xax ax">
            <van-row>
              <van-col span="6">
                姓名 :
                <span style="color: crimson;">{{ social.name }}</span>
              </van-col>
              <van-col span="8">基数</van-col>
              <van-col span="4" style="font-size: 14px;">比例</van-col>
              <van-col span="6">金额</van-col>
            </van-row>
          </div>
          <div class="xa">
            <van-row>
              <van-col span="4" class="ma xc">公积金</van-col>
              <van-col span="2" class="max xxx">
                企业
                <span style="border-top: 1px solid gray; display: inline-block; width: 30px;">个人</span>
              </van-col>
              <van-col span="8" class="ma xc axx">{{ fund[0].f_base }}</van-col>
              <van-col span="2" class="ma xx">
                {{ fund[0].ratio }}%
                <br >
                {{ fund[0].ratio }}%
              </van-col>
              <van-col span="4" class="ma xx mc">
                {{ fund[0].fund_client }}
                <br >
                {{ fund[0].fund_person }}
              </van-col>
            </van-row>
          </div>
          <div class="xa">
            <van-row>
              <van-col span="4" class="ma xc" style="color: #008C00;">总计</van-col>
              <van-col span="4" />
              <van-col span="14" class="ma xc" style="font-size: 14px;color: orange; text-align: left;">{{ fund[0].total_amount }}</van-col>
            </van-row>
          </div>
        </div>
      </div>
      <div v-if="!fund[0].is_show &&!social.is_show ">
        <van-empty image="search" description="暂无数据" />
      </div>
    </div>

  </div>
</template>

<script>

import { Toast } from 'vant';
import { fundetail } from '@/api/Hrfund';
import { socialDetail } from '@/api/Hrfund';
import { List } from '@/api/Hrclient';
import { Wxlist } from '@/api/Hremployee';
import { conso } from '../../../utils/date.js';
export default {
  name: 'FundDetailPerson',
  data() {
    return {
      iconSrc: ['../../static/icon/社保.png', '../../static/icon/公积金.png'],
      activeNames: ['1'],
      Searvalue: '',
      show3: false,
      xa_show: false,
      social: {
        name: [],
        is_show: false,
        s_base: 0,
        pension_client_base: 0,
        pension_lower_limit: 0,
        pension_client_ratio: 0,
        pension_person_ratio: 0,
        unemp_upper_base: 0,
        injuries_upper_base: 0,
        bear_upper_base: 0,
        hosp_upper_limit: 0
      },

      fund: [{ is_show: false }],
      socialx: [],
      social_id: 0,
      minDate: new Date(1960, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      queryCondition: {
        total: this.CONST.PAGINATION.TOTAL,
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.ROWS,
        sort: 'id',
        order: 'desc',

        begin_consult_date: null,
        end_consult_date: null,
        status: null,
        phone: ''
      },
      show2: false,
      show: true,
      show4: false,
      timeValue: sessionStorage.getItem('timeValue')
    };
  },
  beforeMount() {
    this.addDate();
    this.query();
  },
  mounted() {

  },
  methods: {
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },

    addDate() {
      const nowDate = new Date();
      const date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1
      };
      if (date.month >= 1 && date.month <= 9) {
        date.month = `0${date.month}`;
      }
      const systemDate = date.year + '-' + `${date.month}` + '-' + '01';
      if (this.timeValue === null) {
        this.timeValue = systemDate;
      }
    },
    _datex(value) {
      const xa = value;
      conso(xa);
      this.show2 = JSON.parse(sessionStorage.getItem('show2'));
      this.timeValue = sessionStorage.getItem('timeValue');
      this.query();
    },
    _formatter() {
      this.formatter();
    },
    onSearch() {
      this.queryCondition.page = 1;
      this.query();
    },
    query() {
      this.social = {};
      this.social_id = 0;
      this.socialx = [];
      this.fund = [];
      this.fund.push({ is_show: false });
      this.social.is_show = false;
      if (sessionStorage.getItem('emp_id') !== 'null') {
        Wxlist({ id: parseInt(sessionStorage.getItem('emp_id')) }).then(res => {
          this.social.name = res.rows[0].name;
          sessionStorage.setItem('name', res.rows[0].name);
        });
        const client_id = parseInt(sessionStorage.getItem('client_id'));
        console.log(sessionStorage.getItem('client_id') !== null);
        if (sessionStorage.getItem('client_id') !== null) {
          List({ client_id }).then(res => {
            sessionStorage.setItem('social_id', res.rows[0].social_id);
            this.social.social_id = res.rows[0].social_id;
            this.social_id = res.rows[0].social_id;
            if (sessionStorage.getItem('who') === '1') {
              this.social.username = sessionStorage.getItem('username');
            }
            fundetail({
              client_id,
              fund_id: res.rows[0].ss_fund_id,
              curr_date: this.timeValue,
              emp_name: this.social.username,
              total: this.queryCondition.total,
              page: this.queryCondition.page,
              rows: 10
            }).then(res => {
              if (res.rows !== null) {
                for (let i = 0; i < res.rows.length; i++) {
                  this.fund.push({
                    fund_client: parseInt(res.rows[i].fund_client).toFixed(2),
                    fund_person: parseInt(res.rows[i].fund_person).toFixed(2),
                    f_base: res.rows[i].f_base !== undefined ? res.rows[i].f_base : null,
                    total_amounts: parseInt(res.rows[i].total_amount).toFixed(2),
                    ratio: Math.floor((res.rows[i].fund_person / res.rows[i].f_base) * 100),
                    total_amount: parseInt(res.obj.total_amount).toFixed(2),
                    total: res.rows.total,
                    is_show: true
                  });
                  this.fund[0].is_show = true;
                }
              } else {
                this.fund.push({ is_show: false });
              }
            });
            socialDetail({
              client_id,
              social_id: res.rows[0].social_id,
              curr_date: this.timeValue,
              emp_name: this.social.username,
              total: this.queryCondition.total,
              page: this.queryCondition.page,
              rows: 10
            }).then(res => {
              if (res.rows != null) {
                const len = res.rows.length;
                const resl = res.rows;
                let id_card = null;
                for (let i = 0; i < len; i++) {
                  if (sessionStorage.getItem('id_card') === resl[i].id_card) {
                    const resx = res.rows[i];
                    id_card = resl[i].id_card;
                    this.social.pension_client_base = resx.pension_base;
                    this.social.unemp_upper_base = resx.unemp_base;
                    this.social.injuries_upper_base = resx.injuries_base;
                    this.social.hosp_upper_limit = resx.hosp_base;
                    this.social.pension_client_ratio = parseFloat(resx.pension_client_ratio) * 100;
                    this.social.pension_person_ratio = parseFloat(resx.pension_person_ratio) * 100;
                    this.social.unemp_client_ratio = parseFloat(resx.unemp_client_ratio) * 100;
                    this.social.unemp_person_ratio = parseFloat(resx.unemp_person_ratio) * 100;
                    this.social.injuries_client_ratio = parseFloat(resx.injuries_client_ratio) * 100;
                    this.social.hosp_client_ratio = parseFloat(resx.hosp_client_ratio) * 100;
                    this.social.hosp_person_ratio = parseFloat(resx.hosp_person_ratio) * 100;
                    this.social.client_money = resx.pension_client;
                    this.social.person_money = resx.pension_person;
                    this.social.unemp_client_money = resx.unemp_client;
                    this.social.unemp_person_money = resx.unemp_person;
                    this.social.injuries_money = resx.injuries_client;
                    this.social.hosp_client_upper_money = resx.hosp_client;
                    this.social.hosp_person_upper_money = resx.hosp_person;
                    this.social.person_total = resx.person_total;
                    this.social.client_total = resx.client_total;
                    this.social.totalX = res.obj.total;
                    this.social.total = resx.total;
                    this.social.is_show = true;
                    this.show = true;
                  }
                  if (id_card === null) {
                    this.social = [];
                    this.social.name = sessionStorage.getItem('name');
                    Toast.fail('当前属期暂无当前员工信息', sessionStorage.getItem('name'));
                    this.show = false;
                  }
                }
                this.queryCondition.total = res.total || 0;
              } else if (res.total === 0) {
                this.social.is_show = false;
              }
            });
          });
        }
      }
    },

    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {}
  }
};
</script>

<style scoped>
.xa {
  text-align: center;
  margin: 10px 0px;
  border-right: 1px #888888 solid;
  border-bottom: 1px #888888 solid;
}

.xas {
  text-align: center;
  margin: 10px 0px;
  background-color: forestgreen;

  border-right: 1px royalblue solid;
  border-bottom: 1px royalblue solid;
}
.xax {
  text-align: center;
  margin: 10px 0px;
  border-right: 1px forestgreen solid;
  border-bottom: 1px forestgreen solid;
}
.ax {
  margin: 10px 0px;
  height: 41.6px;
  line-height: 41.6px;
}
.he {
  line-height: 40px;
  height: 40px;
}
.ma {
  margin-top: 2px;
  text-align: right;
}
.max {
  margin-top: 2px;
  text-align: center;

  font-size: 14px;
}
.xc {
  line-height: 41.6px;
  height: 41.6px;
  text-align: center;
  font-size: 14px;
  /* border: 1px solid beige; */
}
.xx {
  height: 41.6px;
  margin-left: 20px;
  color: seagreen;
  font-size: 14px;
}
.xxx {
  height: 41.6px;
  text-align: center;
  font-size: 12px;
}
.mc {
  color: darkorange;
  font-size: 14px;
}
.axx {
  color: #008c00;
  font-size: 14px;
}
.van-tabbar--fixed >>> .van-pagination {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/hr/fund/fund-detail-person.vue